import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  REPORT_CATEGORY: {
    path: `${baseRoutes.adminBaseRoutes}/report-category`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-report" />
      </span>
    ),
  },
};

export default accessRoute;
